import React from 'react';
import PropTypes from 'prop-types';

const PricesBabysitter = ({ priceListBabysitter }) => (
  <>
    <ul className="pricelist-wrapper">
      {priceListBabysitter.map((position, index) => {
        const { type, title, price, text } = position;

        if (type === 'section') {
          return (
            <li key={`section-${index}`} className="babysitter-section-title">
              <h3>{title}</h3>
            </li>
          );
        }

        if (type === 'note') {
          return (
            <li key={`note-${index}`} className="babysitter-note">
              <p><em>Note: {text}</em></p>
            </li>
          );
        }

        if (type === 'item') {
          const isHourlyRate = price && /^\d+$/.test(price);
          const description = isHourlyRate ? `€${price}/hour` : price;

          return (
            <li key={`item-${index}`}>
              <div className="price-list-item">
                <div className="price-list-header">
                  <span className="price-list-name">{title}</span>
                  <span className="price-list-separator" />
                  <span className="price-list-price">
                    {isHourlyRate ? `${price} €` : description}
                  </span>
                </div>
                {isHourlyRate && <p className="price-list-description">{description}</p>}
              </div>
            </li>
          );
        }

        return null;
      })}
    </ul>
  </>
);
PricesBabysitter.propTypes = {
  priceListBabysitter: PropTypes.array,
};
export default PricesBabysitter;
